import { Action } from '@ngrx/store';
import { PaginationState, SearchPageResultState } from '../../../../core/features/store/base-feature-state';
import { AssignedShipToPage } from '../../../../core/model';
import { loaderReducer } from '../../../../core/state/utils/loader';
import { SoldToActions } from '../actions';
import { AVAILABLE_SHIP_TOS } from '../sold-to-state';
import { reducer as availableShipTosEntriesReducer } from './sold-to-available-ship-tos-entries.reducer';

export const initialState: PaginationState<SearchPageResultState> = {
  lastUpdateTime: undefined,
  pages: {},
  pagination: undefined,
  sorts: [],
};

export function reducer(state = initialState, action: Action): any {
  switch (action.type) {
    case SoldToActions.AvailableShipTosActionTypes.LoadAvailableShipTos:
    case SoldToActions.AvailableShipTosActionTypes.LoadAvailableShipTosFail: {
      const availableShipTosAction = <SoldToActions.AvailableShipTosActions>action;
      const searchParams = availableShipTosAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(AVAILABLE_SHIP_TOS, availableShipTosEntriesReducer)(
        undefined,
        availableShipTosAction
      );
      return {
        ...state,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    case SoldToActions.AvailableShipTosActionTypes.LoadAvailableShipTosSuccess: {
      const successAction = <SoldToActions.LoadAvailableShipTosSuccess>action;
      const payload: AssignedShipToPage = successAction.payload;
      const searchParams = successAction.searchParams;
      const loaderState = loaderReducer<SearchPageResultState>(AVAILABLE_SHIP_TOS, availableShipTosEntriesReducer)(
        { ...state.pages[searchParams.page] },
        successAction
      );
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        pagination: payload.pagination,
        sorts: payload.sorts,
        pages: {
          ...state.pages,
          [searchParams.page]: loaderState,
        },
      };
    }
    default:
      return state;
  }
}
